import { createStore } from "vuex";
import auth from "./modules/auth";
import notificator from "./modules/notificator";
import users from "./modules/users";
import dealers from "./modules/dealers";
import loans from "./modules/loans";
import contacts from "./modules/contacts";
import vehicles from "./modules/vehicles";
import garages from "./modules/garages";
import contracts from "./modules/contracts";
import customerPortal from "./modules/customerPortal";

export interface State {
  isLoading: boolean;
  openDrawer: boolean;
}

const debug = process.env.NODE_ENV !== "production";

export default createStore({
  strict: debug,
  modules: {
    auth,
    notificator,
    users,
    dealers,
    loans,
    contacts,
    vehicles,
    garages,
    contracts,
    customerPortal,
  },
  state: {
    isLoading: false,
    openDrawer: true,
  },
  mutations: {
    SET_LOADING(state: State, payload: boolean) {
      state.isLoading = payload;
    },

    toggleDrawer(state: State) {
      state.openDrawer = !state.openDrawer;
    },

    setDrawerOpen(state: State, isOpen: boolean) {
      state.openDrawer = isOpen;
    },
  },
  actions: {
    SET_LOADING({ commit }, payload: boolean) {
      commit("SET_LOADING", payload);
    },
  },
});
